import _ from 'lodash';
export const compareFields = (eventA: any, eventB: any) =>
  _.isEqual(eventA?.startDate, eventB?.startDate) &&
  _.isEqual(eventA?.endDate, eventB?.endDate) &&
  _.isEqual(eventA?.venue, eventB?.venue) &&
  _.isEqual(eventA?.isRussia, eventB?.isRussia) &&
  _.isEqual(eventA?.dirRegions, eventB?.dirRegions) &&
  _.isEqual(eventA?.countries, eventB?.countries);
